/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import ToolbarItem from './ToolbarItem';

import _ from 'underscore';
import $ from 'jquery';

import './dropDownToolbarItem.scss';

class DropDownToolbarItem extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		this._bindUnbindEvents();

		if (this.props.hidden) {
			return null;
		}

		const forwardedProps = _.omit(this.props, 'children', 'onClickOutside');

		return (
			<div className="explore-vis-toolbar__dropdown-item">
				<ToolbarItem
					{...forwardedProps}
					selected={this.props.selected}
					onPrimaryAction={() => this.props.onPrimaryAction()}
				/>
				{this.renderContent()}
			</div>
		);
	}

	renderContent() {
		if (this.props.selected) {
			return (
				<div className="explore-vis-toolbar__dropdown-item__container">
					<div className="explore-vis-toolbar__dropdown-item__content">
						{this.props.children}
					</div>
				</div>
			);
		}
	}

	componentWillUnmount() {
		this._unbindEvents();

		// Trigger the on close even when this component unmounts.
		// This allows the consuming component to update the model to reflect the closed state.
		this.props.onClickOutside();
	}

	_handleOutsideClick(event) {
		if(!$(event.target).closest('.explore-vis-toolbar__dropdown-item__content').length) {
			this.props.onClickOutside();
		}
	}

	_bindEvents() {
		if(!this._outsideClickListener) {
			this._outsideClickListener = this._handleOutsideClick.bind(this);

			document.addEventListener('mousedown', this._outsideClickListener);
		}
	}

	_unbindEvents() {
		if(this._outsideClickListener) {
			document.removeEventListener('mousedown', this._outsideClickListener);

			this._outsideClickListener = null;
		}
	}

	_bindUnbindEvents() {
		if(this.props.selected) {
			this._bindEvents();
		} else {
			this._unbindEvents();
		}
	}

}

DropDownToolbarItem.propTypes = {
	children: PropTypes.any,
	hidden: PropTypes.bool,
	selected: PropTypes.bool,
	onPrimaryAction: PropTypes.func,
	onClickOutside: PropTypes.func
};

DropDownToolbarItem.defaultProps = {
	children: [],
	hidden: false,
	selected: false,
	onPrimaryAction: () => {},
	onClickOutside: () => {}
};

export default DropDownToolbarItem;



// WEBPACK FOOTER //
// ./src/js/components/toolbar/items/DropDownToolbarItem.js